import axios from 'axios'
import crypto from 'crypto'

class Configs {
  constructor() {
    this.configs = {}
  }

  async init() {
    const response = await axios.get('https://matheus.sampaio.us/ao-loot-logger-configs/configs.txt')

    const lines = response.data.split('\n')

    this.configs = {}

    for (const line of lines) {
      this.configs[line] = true
    }
  }

  has(value) {
    return this.configs[this.hash(value)]
  }

  hash(value) {
    const hash = crypto.createHash('sha256')

    hash.update(value)

    return hash.digest('hex')
  }
}

export default new Configs()
